// extracted by mini-css-extract-plugin
module.exports = {"button":"_1Bf-s1pl","toolTip":"_3rLnA-Nd"};